export const getServerRedirectedFrom = (state) =>
  (state.serverRedirectedFrom?.url && !state.serverRedirectedFrom?.processed
    ? state.serverRedirectedFrom?.url
    : null)
